export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';